module.exports = __webpack_public_path__ + "rotary_straight.svg?1c43db7b72ab11c3f7a833b6484c6bc5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/rotary_straight.svg
// module id = 214
// module chunks = 0